// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:9568cd85-4d33-4173-a263-52f8bc979c1d",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_yHuVximzv",
    "aws_user_pools_web_client_id": "7vmm4fald6qhssoh4tkh83dqse",
    "oauth": {},
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "rsvps-prod",
            "region": "us-west-2"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "rsvps",
            "endpoint": "https://xr5ckc0ip9.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_content_delivery_bucket": "wedding-site-20200218002526-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://dn5gjtfv0x1sn.cloudfront.net"
};


export default awsmobile;
